import React from "react"
import { useTranslation } from "react-i18next"

import classes from "./OrdersEmptyList.module.scss"

const OrdersEmptyList = () => {
  const [t] = useTranslation()

  return (
    <caption className={classes["no"]}>
      {t("هیچ_سفارشی_یافت_نشد")}
    </caption>
  )
}

export default OrdersEmptyList